// 모던 파스텔톤 테마 팔레트 (사용자 캡쳐 참고)
const pastelColors = [
  '#FFB74D', // Soft Orange
  '#81C784', // Soft Green
  '#64B5F6', // Soft Blue
  '#BA68C8', // Soft Purple
  '#F06292', // Soft Pink
  '#4DD0E1', // Soft Cyan
  '#DCE775', // Light Yellow Green
  '#FF8A65', // Coral
  '#90A4AE', // Blue Grey
  '#A1887F'  // Soft Brown
];

// 메모리에 캐싱하여 렌더링간 항상 동일한 회사-색상 매핑 유지
const companyColorCache = {};
let colorIndex = 0;

export const getCompanyColor = (companyName) => {
  if (!companyName) return '#F8F9FA'; // 기본 백그라운드 색상
  if (!companyColorCache[companyName]) {
    companyColorCache[companyName] = pastelColors[colorIndex % pastelColors.length];
    colorIndex++;
  }
  return companyColorCache[companyName];
};

export const getCompanyColorRgba = (companyName, alpha = 0.2) => {
  const hex = getCompanyColor(companyName);
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
